import {
    Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, MenuItem, TextField
} from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { api } from "../../api/API";
import { ApiToken } from "../../api/ApiTokens";
import { useSnackAction } from "../../misc/SnackAction";

// every token expires; these are the windows on offer
const lifetimes = [
    { days: 30, label: "30 days" },
    { days: 90, label: "90 days" },
    { days: 365, label: "1 year" },
];

export function ApiTokenEditor(props: {
    onClose: () => void;
    onCreated: (token: ApiToken) => void;
}) {
    const [name, setName] = useState("");
    const [days, setDays] = useState(365);

    const save = useSnackAction(async () => {
        const created = await api.apiTokens.upsert({
            name: name,
            expiresAt: moment().add(days, "days").toISOString(),
        });

        props.onCreated(created);
    }, { success: "Token created" });

    return (
        <Dialog open fullWidth maxWidth="xs" onClose={props.onClose}>
            <DialogTitle>New api token</DialogTitle>
            <DialogContent>
                <DialogContentText variant="body2">
                    The token acts as you: it reaches what you reach, with your role.
                </DialogContentText>

                <form id="api-token-editor" onSubmit={e => {
                    e.preventDefault();
                    save.callback(null);
                }}>
                    <div style={{ height: 16 }} />
                    <TextField label="Name" fullWidth autoFocus autoComplete="off"
                               placeholder="What's using it"
                               value={name} onChange={e => setName(e.target.value)} />
                    <div style={{ height: 8 }} />
                    <TextField label="Expires" select fullWidth
                               value={days} onChange={e => setDays(parseInt(e.target.value))}>
                        {lifetimes.map(item => (
                            <MenuItem key={item.days} value={item.days}>{item.label}</MenuItem>
                        ))}
                    </TextField>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Cancel</Button>
                <Button type="submit" form="api-token-editor" variant="contained"
                        disabled={save.loading || !name.trim()}>
                    Create
                </Button>
            </DialogActions>
        </Dialog>
    );
}
